import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Textarea from 'react-textarea-autosize';
import Button from './Button';

const TextComposerModalBody = ({
  title,
  TitleIcon,
  value = '',
  placeholder,
  label,
  setRef,
  isTextTop,
  infoText,
  minRows = 3,
  maxRows = 10,
  state = 'composing',
  saveButtonLabel,
  onSubmit,
  disableSubmit = true,
  actions: Actions,
  className,
  ...props
}) => {
  const [val, setVal] = React.useState(value);

  React.useEffect(() => {
    setVal(value);
  }, [value]);

  const cn = useClassNames(() => ['flex', 'flex-col', 'rounded', className], [className, state]);
  // workaround for wrong height of the Textarea when modal is rendered
  React.useEffect(() => {
    const workaround = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
    return () => {
      clearTimeout(workaround);
    };
  }, []);

  return (
    <form
      data-component="TextComposerModalBody"
      className={cn}
      {...props}
      onSubmit={event => {
        if (state === 'composing') onSubmit(event, val);
        event.preventDefault();
      }}
    >
      {isTextTop && <p className="text-sm mb-1">{infoText}</p>}
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="flex flex-col flex-1 full-width">
        {label && <span className="font-semibold mb-1">{label}</span>}
        <Textarea
          className="p-3 resize-none border border-slate-500 focus:border-blue-500 rounded outline-none placeholder-slate-500 leading-tight"
          value={val}
          placeholder={placeholder}
          minRows={minRows}
          maxRows={maxRows}
          ref={setRef}
          readOnly={state !== 'composing'}
          maxLength="2000"
          onChange={event => {
            setVal(event.target.value);
          }}
        />
      </label>
      {Actions && <Actions textareaValue={val} />}
      {!isTextTop && <p className="text-sm mt-1">{infoText}</p>}
      <div className="flex justify-center lg:justify-end mt-8">
        <Button
          className={[state !== 'composing' && 'pointer-events-none']}
          isDisabled={disableSubmit && val.trim() === ''}
          isLoading={state !== 'composing'}
          type="submit"
        >
          {saveButtonLabel}
        </Button>
      </div>
    </form>
  );
};

TextComposerModalBody.defaultProps = {
  setRef: () => {},
};

TextComposerModalBody.propTypes = {
  title: PropTypes.string,
  TitleIcon: PropTypes.node,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  setRef: PropTypes.func,
  label: PropTypes.string,
  infoText: PropTypes.node,
  minRows: PropTypes.number,
  isTextTop: PropTypes.bool,
  maxRows: PropTypes.number,
  state: PropTypes.oneOf(['composing', 'loading']),
  saveButtonLabel: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  actions: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default TextComposerModalBody;
